module.exports = __webpack_public_path__ + "img/code-review-icon.71060ef5.svg";